module.exports = __webpack_public_path__ + "img/bg_contato.37b146da.png";